import { PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Entity } from "typeorm";

@Entity('employee_team')
export class EmployeeTeamEntity{
   
    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'employee_name'
    })
    employeeName: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'shift_code'
    })
    shiftCode: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'workstation_team'
    })
    workStationTeam: string;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;
    
    @Column("varchar", {
        nullable: false,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;
 
    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}